//
// Copyright (c) 2011-2024 by Curalate, Inc
//

import { useQuery } from '@tanstack/react-query';

import { getUsers as getAllUsers } from '@apis/users/usersApi';
import { QueryKeyConstants } from '@queries/QueryKeyConstants';

export const useAllUsersQuery = () =>
  useQuery({
    queryKey: [
      QueryKeyConstants.MediaFilters,
      QueryKeyConstants.MediaFiltersAllUsers,
    ],
    queryFn: ({ signal }) => getAllUsers({ signal }),
    staleTime: Infinity,
  });
